import React, { useEffect } from "react";
import { Col, Row } from "antd";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { extractDate } from "../../config/helpers";

const LimoBookingDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data;
  useEffect(() => {
    if(!data){
      navigate(-1)
    }
    // eslint-disable-next-line
  },[])
  return (
    <>
      <Row justify="center">
        <Col md={23} xs={22}>
          <div
            className="bg-white rounded-lg sm:py-16 py-8 my-12"
            style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
          >
            <div className="flex justify-start mx-1 lg:mx-8 mb-6">
              <div className="flex justify-center items-center">
                <IoIosArrowRoundBack
                  onClick={() => navigate(-1)}
                  className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
                />
                <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                  Payment Membership Details
                </h3>
              </div>
            </div>

            <Row justify="start" className="my-4 mx-2 lg:mx-10">
              <Col xs={22} md={24} lg={20} xxl={12}>
                <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:p-10 p-6 mx-4">
                  <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                    Subscription Details
                  </h5>
                  <div className="my-4">
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={24}>
                        <div className="items-start">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Subscription Title
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {data?.plan?.title}
                          </p>
                        </div>
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={24}>
                        <div className="items-start">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Purchase Date
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            {extractDate(data?.subscription?.purchaseDate)}
                          </p>
                        </div>
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={24}>
                        <div className="items-start">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Expiry Date
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                          {extractDate(data?.subscription?.expirationDate)}
                          </p>
                        </div>
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={24}>
                        <div className="items-start">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Amount Paid
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            
                          ${(data?.plan?.totalDiscountedAmount)}
                          </p>
                        </div>
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={24}>
                        <div className="items-start">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Total Hours
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                            4
                          {(data?.plan?.totalHours)}
                          </p>
                        </div>
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={24}>
                        <div className="items-start">
                          <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                            Reminding Hours
                          </h5>
                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                          {(data?.subscription?.remainingHours)}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* <Row justify="center">
        <Col md={23} xs={22}>
          <div
            className="bg-white rounded-lg sm:py-16 py-4 px-10 mb-12"
            style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
          >
            <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black py-4">
              Car Details
            </h3>
            <Row justify="left" gutter={[32, 32]}>
              <Col xxl={10} xl={10} xs={24} className="customSlider sm:px-4 self-center">
                <div>
                  <Slider
                    asNavFor={nav2}
                    ref={sliderRef1}
                    arrows={false}
                    adaptiveHeight={true} // Ensure slider adapts to image height
                    autoplay={false} // Disable autoplay to avoid constant re-rendering
                  >
                    {images.map((img, index) => (
                      <div key={index} className="w-full">
                        <img src={ImageUrl(img)} alt={`Slide ${index}`} />
                      </div>
                    ))}
                  </Slider>
                  <Slider asNavFor={nav1} ref={sliderRef2} {...sliderSettings}>
                    {images.map((img, index) => (
                      <div key={index}>
                        <img src={ImageUrl(img)} alt={`Thumbnail ${index}`} />
                      </div>
                    ))}
                  </Slider>
                </div>
              </Col>
              <Col xxl={12} xl={14} xs={24}>
                <div className="flex justify-center my-4 w-full">
                  <div className="flex flex-col items-start w-full">
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Car Brand
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      ABC Brand
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Car Model
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      2024
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Car Type
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      Electric
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Service Type
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      Black Luxury
                    </p>
                  </div>
                  <div className="flex flex-col items-start w-full">
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Car Name
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      Toyota Camry
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Car Number
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      JMP-14587-JX
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Passenger Capacity
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      04
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row> */}
    </>
  );
};

export default LimoBookingDetails;
